import React from 'react';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, ResponsiveContainer, Text } from 'recharts';
import classnames from 'classnames';

// local dependencies
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { withNetworkState } from 'ui/hoc/withNetworkState';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { lineChart as LineChartView } from './lineChart.view';
 *
 * // render
 * <LineChartView propName='propValue'/>
 */
export const lineChartSuccess = ( props ) => {

    const {
        
        // width,
        // height,
        margin,
        minTickGap,
        XaxisLine,
        YaxisLine,
        YtickLine,
        XtickLine,
        data,
        interval,
        yAxislabel
    } = props;

    const CustomizedTick =( custom ) => {
        const { x, y, payload } = custom;
        return (

        //  <g transform={`translate(${x},${y})`}>
         <Text x={x} y={y} dy={15} width={10} textAnchor="middle" fill="#000" >{ payload.value }</Text>

    //    </g>
     );
    };

    const CustomizedTickYaxis =( custom ) => {
        const { x, y, payload } = custom;
        return <Text x={x} y={y} dy={3} width={10} textAnchor="end" fill="#000">{ payload.value + yAxislabel }</Text>;
    };

    const widgetClassName = classnames( 'ui-line-chart', props.className );
  
    
    return (
        <div className={ widgetClassName }>
            <ResponsiveContainer>
            <LineChart data={ data } margin={ margin }>
                <CartesianGrid vertical={false} />
                <XAxis
                    dataKey="name"
                    axisLine={ XaxisLine }
                    tickLine={ XtickLine }
                    interval={ interval }
                    minTickGap={ minTickGap }
                    padding={ { left: 20, right: 20 } }
                    tick={<CustomizedTick />}
                />
                <YAxis  axisLine={ YaxisLine } tickLine={ YtickLine } tick={<CustomizedTickYaxis />}  />
                <Line type="linear" dataKey="value" stroke="#629bcd" strokeWidth={ 2 } />
            </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

// set display name
lineChartSuccess.displayName = 'lineChartSuccess';

// set default props
lineChartSuccess.defaultProps = {};

// prop types
lineChartSuccess.propTypes = {};

/* ******************************************************** */

export const lineChartPreloader = () => {
	return (
		<div className = 'ui-line-chart-preloader'>
			<WidgetPreloader/>
		</div>
	);
};

// set display name
lineChartPreloader.displayName = 'lineChartPreloader';

// set default props
lineChartPreloader.defaultProps = {};

// prop types
lineChartPreloader.propTypes = {};

/* ******************************************************** */

export const lineChart = withNetworkState( lineChartPreloader, lineChartSuccess );
